import type { PropsWithChildren } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface FormItemGroupProps {
  fields: Record<"id", string>[];
  hasReachedLimit: boolean;
  hasReachedMinimum: boolean;
  index: number;
  onDuplicateClick: () => void;
  onRemoveClick: () => void;
  title?: string;
}

export const FormItemGroup = ({
  index,
  fields,
  hasReachedLimit,
  hasReachedMinimum,
  onRemoveClick,
  onDuplicateClick,
  children,
  title,
}: PropsWithChildren<FormItemGroupProps>) => (
  <div
    className={classNames("flex flex-col gap-y-2 px-6", {
      "pt-5": index > 0 && index < fields.length,
    })}
  >
    <div className="flex flex-row justify-between">
      <Typography.LabelSm weight="semibold">
        {title || t("item")}
      </Typography.LabelSm>
      <div className="flex flex-row gap-x-2">
        <Button
          type="button"
          variant="circle-plain"
          disabled={hasReachedMinimum}
          className="hover:text-dark !hover:bg-primary !p-1"
          onClick={onRemoveClick}
        >
          <Icon type="16-trash-bin" viewBox="0 0 16 16" className="!h-4 !w-4" />
        </Button>
        <Button
          disabled={hasReachedLimit}
          variant="circle-plain"
          className="hover:text-dark !hover:bg-primary !p-1"
          type="button"
          onClick={onDuplicateClick}
        >
          <Icon type="16-copy" viewBox="0 0 16 16" className="!h-4 !w-4" />
        </Button>
      </div>
    </div>
    {children}
  </div>
);
